module.exports = __webpack_public_path__ + "h5/img/xiaoxi.90db5794.png";